const RECENT_SCRIPS_KEY = "orderInitiate_recentScrips";
const MAX_RECENT_SCRIPS = 5;

function normalizeTransactionType(raw) {
  const side = String(raw ?? "").trim().toLowerCase();
  return side === "sell" ? "Sell" : "Buy";
}

function normalizeEntry(raw) {
  if (!raw || typeof raw !== "object") return null;
  const name = String(raw.name ?? "").trim();
  if (!name) return null;
  return {
    name,
    exchange: String(raw.exchange ?? "").trim(),
    segment: String(raw.segment ?? "").trim(),
    symbol: String(raw.symbol ?? "").trim(),
    option_type: String(raw.option_type ?? "").trim(),
    strike_price: raw.strike_price ?? "",
    expiry_date: String(raw.expiry_date ?? "").trim(),
    transactionType: normalizeTransactionType(raw.transactionType),
  };
}

export function loadRecentScrips() {
  try {
    const raw = window.localStorage.getItem(RECENT_SCRIPS_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.map(normalizeEntry).filter(Boolean).slice(0, MAX_RECENT_SCRIPS);
  } catch {
    return [];
  }
}

function saveRecentScrips(list) {
  try {
    window.localStorage.setItem(RECENT_SCRIPS_KEY, JSON.stringify(list.slice(0, MAX_RECENT_SCRIPS)));
  } catch {
    /* ignore */
  }
}

export function rememberRecentScrip(entry, prev = loadRecentScrips()) {
  const nextEntry = normalizeEntry(entry);
  if (!nextEntry) return prev;
  const next = [nextEntry, ...prev.filter((p) => p.name !== nextEntry.name)].slice(0, MAX_RECENT_SCRIPS);
  if (JSON.stringify(next) === JSON.stringify(prev)) return prev;
  saveRecentScrips(next);
  return next;
}

export function recentScripEntryFromRow(selection, tradingSymbol) {
  const name = String(tradingSymbol ?? "").trim();
  if (!name || !selection) return null;
  return {
    name,
    exchange: selection.exchange,
    segment: selection.segment,
    symbol: selection.symbol,
    option_type: selection.option_type,
    strike_price: selection.strike_price,
    expiry_date: selection.expiry_date,
    transactionType: selection.transactionType,
  };
}

function formatExpiryDisplay(apiDate) {
  const raw = String(apiDate ?? "").trim();
  if (!raw) return "";
  const iso = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (iso) return `${iso[3]}-${iso[2]}-${iso[1]}`;
  return raw;
}

function formatStrikeDisplay(raw) {
  if (raw === "" || raw == null) return "";
  const n = Number(raw);
  if (!Number.isFinite(n) || n === 0) return "";
  return Number.isInteger(n)
    ? String(n)
    : n.toLocaleString("en-IN", { maximumFractionDigits: 2 });
}

function displaySegment(exchange, segment) {
  const seg = String(segment ?? "").trim();
  const ex = String(exchange ?? "").trim();
  if (!seg) return "";
  if (ex && seg.toUpperCase().startsWith(`${ex.toUpperCase()}-`)) {
    return seg.slice(ex.length + 1);
  }
  return seg;
}

/** Buy / Sell label stored with the scrip. */
export function recentScripSide(entry) {
  return normalizeTransactionType(entry?.transactionType);
}
export function recentScripMetaParts(entry) {
  if (!entry) return [];
  const parts = [];
  const exchange = String(entry.exchange ?? "").trim();
  const segment = displaySegment(exchange, entry.segment);
  const optionType = String(entry.option_type ?? "").trim().toUpperCase();
  const strike = formatStrikeDisplay(entry.strike_price);
  const expiry = formatExpiryDisplay(entry.expiry_date);
  const symbol = String(entry.symbol ?? "").trim();
  const name = String(entry.name ?? "").trim();

  if (exchange) parts.push(exchange);
  if (segment && segment.toUpperCase() !== exchange.toUpperCase()) parts.push(segment);
  if (symbol && symbol.toUpperCase() !== name.toUpperCase()) parts.push(symbol);
  if (
    optionType &&
    optionType !== segment.toUpperCase() &&
    optionType !== exchange.toUpperCase()
  ) {
    parts.push(optionType);
  }
  if (strike) parts.push(strike);
  if (expiry) parts.push(expiry);
  return parts;
}
